import { render, staticRenderFns } from "./hiddenPotential.vue?vue&type=template&id=f531fd90&scoped=true"
import script from "./hiddenPotential.vue?vue&type=script&lang=js"
export * from "./hiddenPotential.vue?vue&type=script&lang=js"
import style0 from "./hiddenPotential.vue?vue&type=style&index=0&id=f531fd90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f531fd90",
  null
  
)

export default component.exports